<div [formGroup]="form">
  <mat-form-field *ngIf="showDateCreationRange" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha Creación</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="chargeDatePicker">
      <input matStartDate formControlName="start" placeholder="Fecha Inicio">
      <input matEndDate formControlName="end" placeholder="Fecha Fin">
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="chargeDatePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #chargeDatePicker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showAsignationDate" appearance="fill" class="w-full">
    <mat-label>Fecha de asignación</mat-label>
    <input matInput [matDatepicker]="pickerAsignation" formControlName="asignationDate" />
    <mat-datepicker-toggle matSuffix [for]="pickerAsignation"></mat-datepicker-toggle>
    <mat-datepicker #pickerAsignation></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngIf="showCreationDate" appearance="fill" class="w-full">
    <mat-label>Fecha de creación</mat-label>
    <input matInput [matDatepicker]="pickerCreation" formControlName="creationDate" />
    <mat-datepicker-toggle matSuffix [for]="pickerCreation"></mat-datepicker-toggle>
    <mat-datepicker #pickerCreation></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngIf="showDueDate" appearance="fill" class="w-full">
    <mat-label>Fecha de vencimiento</mat-label>
    <input matInput [matDatepicker]="pickerDue" formControlName="dueDate" />
    <mat-datepicker-toggle matSuffix [for]="pickerDue"></mat-datepicker-toggle>
    <mat-datepicker #pickerDue></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngIf="showDueDateRange" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha Vencimiento</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="dueDateRange">
      <input matStartDate formControlName="pickerDue_start" placeholder="Fecha Inicio" />
      <input matEndDate formControlName="pickerDue_end" placeholder="Fecha Fin" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="dueDateRange"></mat-datepicker-toggle>
    <mat-date-range-picker #dueDateRange></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showStartTripOne" appearance="fill" class="w-full">
    <mat-label>Fecha inicio de viaje</mat-label>
    <input matInput [matDatepicker]="pickerStart" formControlName="selectedDate" />
    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
    <mat-datepicker #pickerStart></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngIf="showEndTripOne" appearance="fill" class="w-full">
    <mat-label>Fecha fin de viaje</mat-label>
    <input matInput [matDatepicker]="pickerEnd" formControlName="selectedDateEnd" />
    <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
    <mat-datepicker #pickerEnd></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngIf="showStartTrip" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha Inicio de Viaje</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="chargeDatePicker">
      <input matStartDate formControlName="startTrip" placeholder="Fecha Inicio" />
      <input matEndDate formControlName="endTrip" placeholder="Fecha Fin" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="chargeDatePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #chargeDatePicker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showEndTrip" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha Fin de Viaje</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="chargeDatePickerEnd">
      <input matStartDate formControlName="end_startTrip" placeholder="Fecha Inicio" />
      <input matEndDate formControlName="end_endTrip" placeholder="Fecha Fin" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="chargeDatePickerEnd"></mat-datepicker-toggle>
    <mat-date-range-picker #chargeDatePickerEnd></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showUploadDate" appearance="fill" class="w-full">
    <mat-label>Fecha de Carga</mat-label>
    <input matInput [matDatepicker]="pickerUpload" formControlName="uploadDate" />
    <mat-datepicker-toggle matSuffix [for]="pickerUpload"></mat-datepicker-toggle>
    <mat-datepicker #pickerUpload></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngIf="showUploadDateRange" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha Carga de Viaje</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="pickerUploadDateRange">
      <input matStartDate formControlName="pickerUpload_start" placeholder="Fecha Inicio" />
      <input matEndDate formControlName="pickerUpload_end" placeholder="Fecha Fin" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="pickerUploadDateRange"></mat-datepicker-toggle>
    <mat-date-range-picker #pickerUploadDateRange></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showUploadTripDateRange" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha Carga de Viaje</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="chargeDate">
      <input matStartDate formControlName="charge_start" placeholder="Fecha Inicio" />
      <input matEndDate formControlName="charge_end" placeholder="Fecha Fin" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="chargeDate"></mat-datepicker-toggle>
    <mat-date-range-picker #chargeDate></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showExpirationDateRange" appearance="fill" class="modal-input w-full">
    <mat-label>Por Vencimiento</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="expirationDate">
      <input matStartDate formControlName="exp_start" placeholder="Fecha Inicio" />
      <input matEndDate formControlName="exp_end" placeholder="Fecha Fin" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="expirationDate"></mat-datepicker-toggle>
    <mat-date-range-picker #expirationDate></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showDeliveryDate" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha de Entrega</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="deliveryDatePicker">
      <input matStartDate formControlName="startDeliveryDate" placeholder="Fecha Inicio Entrega" />
      <input matEndDate formControlName="endDeliveryDate" placeholder="Fecha Fin Entrega" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #deliveryDatePicker></mat-date-range-picker>
  </mat-form-field>
  <mat-form-field *ngIf="showDateApprovalRange" appearance="fill" class="modal-input w-full">
    <mat-label>Fecha Aprobación</mat-label>
    <mat-date-range-input [formGroup]="form" [rangePicker]="approvalDatePicker">
      <input matStartDate formControlName="approval_start" placeholder="Fecha Inicio">
      <input matEndDate formControlName="approval_end" placeholder="Fecha Fin">
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="approvalDatePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #approvalDatePicker></mat-date-range-picker>
  </mat-form-field>
</div>